import { inject, type App, type Plugin } from "vue";

import { IServices } from "@/app/di";

const SERVICES_KEY = Symbol("app-services");

export const provideServicesPlugin: Plugin = {
  async install(app: App, options: { services: IServices }) {
    app.provide<IServices>(SERVICES_KEY, options.services);
  },
};

export function useServices(): IServices {
  const services = inject<IServices>(SERVICES_KEY);
  if (!services) {
    throw new Error("Services not provided");
  }

  return services;
}
